<template>
  <div class="cm">
    <div class="top_cm">
      <div>
        <span>规范名称</span><el-input  maxlength="100" v-model="searchForm.standardName" clearable placeholder="请输入规范名称"></el-input>
        <span>编号</span><el-input  maxlength="50" v-model="searchForm.standardCode" clearable placeholder="请选择编号"></el-input>
      </div>
      <div>
        <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">查询</el-button>
        <el-button class="mybtny" v-waves icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="table_cm">
      <Table
        ref="multipleTable"
        v-loading="loading"
        :tableData="List"
        :pageSize='pageSize'
        :currentPage="pageIndex"
        :cloumns="cloumns"
        :totalNum="total"
        :pageFlag='true'
        :selection='true'
        @handleCurrentChange="handleCurrentChange"
      >
        <el-table-column
          prop="standardName"
          label="规范名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="standardCode"
          label="编号"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="version"
          label="版本号"
          align="center"
          sortable
        >
        </el-table-column>
      </Table>
    </div>
    <div class="footer">
      <div class="jb-bg btn" @click="affirm">确认</div>
      <div class="btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { GetList } from "@/api/Standard.js";
import Table from "@/components/myTable";
export default {
  components: {
    Table,
  },
  data() {
    return {
      userInfo: '',
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {
        standardName: '',
        standardCode: ''
      },
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getStandardList();
  },
  methods: {
    getStandardList() {
      let params = {
        deptId: this.userInfo.deptId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      GetList(params).then(res => {
        if (res.code == "200") {
          this.List = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getStandardList();
    },
    reset() {
      this.searchForm.standardName = '';
      this.searchForm.standardCode = '';
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getStandardList();
    },
    affirm() {
      let selection = this.$refs.multipleTable.$refs.mytable.selection;
      this.$emit('choosed', selection);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
}
</script>

<style lang='less' scoped>
.cm {
  color: #74c8fe;
  .top_cm {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
    .el-button {
      width: 140px;
      margin-left: 20px;
    }
    .el-select {
      margin: 0 20px;
    }
  }
  .table_cm {
    height: 500px;
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .btn {
    width: 150px;
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 0 10px;
    text-align: center;
    cursor: pointer;
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chooseStandard/index.vue